import { Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from './app.state';

@Injectable()
export class CoreActionService {

    constructor(private ngRedux: NgRedux<IAppState>) {

    }
}
